export type LegacySubcategoryFilters = Record<
  string,
  Array<{ id: number; name: string }>
>;

export type ActiveFilter = {
  name: string;
  handleClick: (id?: string) => void;
};

export enum FilterTypes {
  Category = 'category',
  Subcategory = 'subcategory',
  Brand = 'brand',
  Size = 'size',
  Price = 'price',
  Colour = 'colour',
  Condition = 'condition',
  Location = 'location',
  OnSale = 'onsale',
}

export enum FilterLocation {
  Mobile = 'mobile',
  Desktop = 'desktop',
}
